/**
 * Plans Service
 * Admin-only Stripe price management for the TenderCentriX Discovery plan.
 */
import { api } from './api'

export const plansService = {
    async getAll() {
        const res = await api.get('/billing/admin/plans')
        if (!res.success) throw new Error('Failed to fetch plans')
        return res.data
    },

    async save({ interval, amountMinor, currency, nickname }) {
        const res = await api.put('/billing/admin/plans', { interval, amountMinor, currency, nickname })
        if (!res.success) throw new Error('Failed to save plan')
        return res.data
    },

    async setActive(priceId, active) {
        const res = await api.patch(`/billing/admin/plans/${priceId}`, { active })
        if (!res.success) throw new Error('Failed to update plan')
        return res.data
    },
}

export default plansService
